import { defineMessages } from 'react-intl'

const translations = defineMessages({
  cancelOrder: {
    defaultMessage: 'Cancel Order',
    id: 'msp.account.order_history.order_detail.action.cancel_order'
  },
  orderCancellationTitle: {
    defaultMessage: 'Order Cancellation',
    id: 'msp.account.order_history.order_detail.cancel_order.title'
  },
  orderCancellationDescription: {
    defaultMessage: 'Do you really want to cancel your order?',
    id: 'msp.account.order_history.order_detail.cancel_order.description'
  },
  orderCancellationConfirm: {
    defaultMessage: 'Yes, cancel',
    id: 'msp.account.order_history.order_detail.cancel_order.confirm'
  },
  orderCancellationCancel: {
    defaultMessage: 'No',
    id: 'msp.account.order_history.order_detail.cancel_order.refuse'
  },
  orderCancellationSuccess: {
    defaultMessage: 'Your order has been successfully cancelled',
    id: 'msp.account.order_history.order_detail.cancel_order.success'
  },
  orderCancellationError: {
    defaultMessage: 'Order cancellation failed. Please try again later',
    id: 'msp.account.order_history.order_detail.cancel_order.error'
  }
})

export default translations
